import { z } from "zod";

import { OrganizationDtoSchema } from "../../../dtos/organizations";

export const PriceScraperRequestBodySchema = z.object({
  urls: z.string().array().default([]),
});

export type PriceScraperRequestBodyType = z.infer<
  typeof PriceScraperRequestBodySchema
>;

export const PriceScraperResponseBodySchema = OrganizationDtoSchema;

export type PriceScraperResponseBodyType = z.infer<
  typeof PriceScraperResponseBodySchema
>;
